import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MessageService } from '../../shared/services/message.service';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { DeleteModal } from '../models/delete-modal';
import { CommonMessage } from '../common/common-messages';
import { Constants, DefaultTicketType } from '../common/constants';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { DataShareService } from '../../shared/services/data.service';
import { SearchModel } from '../interface/ticketingsystem/search.model';
import { environment } from '../../../environments/environment';
import { SearchRequestConstants } from '../common/search-request-constants';
import { PaginationInstance } from 'ngx-pagination';
import { WorkTicket } from '../interface/ticketingsystem/work-ticket';
import { TranslateService } from '@ngx-translate/core';
import { Status } from '../enums/ticket-status.enum';
import { TicketType } from '../enums/ticket-type.enum';
import { DepartmentService } from '../services/department.service';
import { PaginationReq } from '../interface/ticketingsystem/bulk-assign-tickets-req';
import { Modal } from 'ngx-modal';
import { CustomerService } from '../services/customer.service';
import { Department } from '../enums/department-type.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ComposeEmailTicketConstants } from '../constants/compose-email.constants';

@Component({
  selector: 'fd-ticket',
  templateUrl: '../templates/template1/views/fd-tickets.component.html',
  styleUrls: ['../templates/template1/themes/default/css/ticket.less', '../templates/template1/themes/default/css/my-team-tickets.component.less']
})
export class FdTicketsComponent implements OnInit {
  @ViewChild('ticketType') ticketType: ElementRef;

  @Input() operatingCountries: any;
  @Input() statusTypes: any;
  @Input() allDepartment: any;
  @Input() isDiputeTicketSearch: boolean;

  userDepartments: any[];
  allTickets: any[] = new Array<WorkTicket>();
  excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
  fdTicketsForm: FormGroup;
  ticketSpamOrUnspamForm: FormGroup;
  isAllSelectedTicketsSpamedOrUnspamed: boolean;

  rightContentWidth = 1000;
  active = true;
  id: any;
  tabTitle: string;
  componentName: any;
  tabModel: ViewTabModel;
  tabs: any[] = new Array<ViewTabModel>();
  existedValues: ViewTabModel[] = new Array<ViewTabModel>();
  deleteModal: DeleteModal;
  justifyingTabs = false;

  ticketTypes: any;
  departments: any[];
  userInfo: UserInfo;
  userId: any;

  fdTickets: any[] = new Array<WorkTicket>();
  showAllTickets = true;
  ticketSearchModel: any;
  ticketTypeOnSelectAll = true;
  departmentOnSelectAll = true;
  assignToOnSelectAll = true;
  statusOnSelectAll = true;
  subTypeOnSelectAll = true;
  countryOnSelectAll = true;
  isClearClicked = false;
  assignedToId: any;
  users: any[];
  pageNumber = 1;
  pageSize = 25;
  pageCount = 0;
  isDesc = true;
  pageSizes: number[] = [10, 25, 50, 75];
  sortColumn: any = 'TICKET_NUMBER';
  sort = 'DESC';
  selectedCountries = [];
  isTicketView: any;
  disputeSearch = false;
  selectedTickets: any[] = new Array<WorkTicket>();
  bulkAssignReq: PaginationReq;
  isBulkAssignSearch: boolean;
  bulkTicketAssignees: any[];
  isSubmitted: boolean;
  isFormInvalid: boolean;
  bulkAssignDepts: any[];
  bulkAssignStatus: any[];
  selectAll = false;
  unAssinged: boolean;
  overDueDisable: boolean;
  ticketsOnSelectAll: any[] = new Array<WorkTicket>();
  message = '';
  closed = 0;
  countryId: number;
  activetab = 1;
  fieldTypes: SearchRequestConstants;
  @ViewChild('spamOrUnspamTicketConfirmationModal')
  spamOrUnspamTicketConfirmation: Modal;
  allfieldsDisable: boolean;
  departmentTimeoutID: any;
  allTicketTypes: any;
  assignedUsers: any;
  fdOperatingCountries: any;
  fdDepartmentId: any;

  /** * Pagination instance - to avoid console warnings - inorder to assign id for pagination */
  public paginationInstance: PaginationInstance = {
    id: 'fd-tickets-pagination',
    itemsPerPage: 10,
    currentPage: 1
  };
  public dropdownSettings: any = {
    typeDropdownList: [],
    typeSelectedItems: [],
    typeIndex: 2,
    subTypeDropdownList: [],
    subTypeSelectedItems: [],
    subTypeIndex: 3,
    statusDropdownList: [],
    statusSelectedItems: [],
    statusIndex: 4,
    departmentDropdownList: [],
    departmentSelectedItems: [],
    departmentIndex: 6,
    assignedToDropdownList: [],
    assignedToSelectedItems: [],
    assignedToIndex: 7,
    countryDropdownList: [],
    countrySelectedItems: [],
    countryIndex: 8,
    settings: {},
  };
  countryDropdownSettings={
    singleSelection: false,
    text: 'select..',
    selectAllText: 'Select All',
    unSelectAllText: 'Select All',
    enableSearchFilter: false,
    classes: 'myclass custom-class',
    badgeShowLimit: 1,
  }

  constructor(private _formbuilder: FormBuilder, private messageService: MessageService, private _cacheService: CacheService,
    private _commonService: CommonService, private _dataShareService: DataShareService, private _translatePipe: TranslateService,
    private departmentService: DepartmentService, private _customerservice: CustomerService, private chRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.buildForm();
    this.buildSpamForm();
    this.intializeMultiselectDropdowns();
    this.dropdownSettings.settings = {
      singleSelection: false,
      text: 'select..',
      selectAllText: 'Select All',
      unSelectAllText: 'Select All',
      enableSearchFilter: false,
      classes: 'myclass custom-class',
      badgeShowLimit: 1,
    };
    this.tabModel = new ViewTabModel();
    this.fieldTypes = new SearchRequestConstants();
    this.subscribeTabContent();
    this.subscribeClosedTabs();
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_TICKETS_VIEW + ']'), AccessLevel.Customer_Service);
    this.assignedToId = this.userInfo.userId;
    this.active = false;
    this.overDueDisable = false;
    this.ticketSearchModel = new SearchModel();
    this.countryId = this.getAllowedCountries();
    this.ticketSearchModel.overDueCount = false;
    this.showAllTickets = false;
    this._dataShareService.customerServiceMessage.subscribe((message) => {
      if (message && message !== '') {
        const splittedMessage = message.split('-');
        this.rightContentWidth = Number(splittedMessage[0]);
      }
    });
    this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
    this.deleteModal.viewActionButtons = false;
    this.isDiputeTicketSearch ? (this.disputeSearch = true) : '';
    this.closed = Status.Closed;
    if (this.userInfo.privileges.departments && !this.userInfo.hasSystemRole) {
      this.userDepartments = this.userInfo.privileges.departments.map(function (a) { return a.id; });
    }
    this.getTicketStatus();
    this.getOperatingCountries(true);
  }

  /**initialize the form */
  buildForm(): void {
    this.unAssinged = true;
    this.fdTicketsForm = this._formbuilder.group(
      {
        ticketNumber: [''],
        operatingCountryId: [''],
        assignTo: [''],
        type: [''],
        subType: [''],
        status: [''],
        email:['',[Validators.pattern(ComposeEmailTicketConstants.EMAIL_REGEXP)]]
      });
  }

  /**  Build form for bulk spam*/
  buildSpamForm() {
    this.ticketSpamOrUnspamForm = this._formbuilder.group({
      ticketId: ['', Validators.required],
    });
  }

  /**reset spam ticket */
  resetTicketSpamOrUnspamForm() {
    this.ticketSpamOrUnspamForm.reset();
    this.isFormInvalid = false;
    this.selectedTickets = [];
    this.ticketSpamOrUnspamForm.controls['ticketId'].setValue('');
  }

  /**initialize  property values for mutltiselect dropdown */
  intializeMultiselectDropdowns() {
    this.dropdownSettings.typeDropdownList = [];
    this.dropdownSettings.typeSelectedItems = [];
    this.dropdownSettings.subTypeDropdownList = [];
    this.dropdownSettings.subTypeSelectedItems = [];
    this.dropdownSettings.statusDropdownList = [];
    this.dropdownSettings.statusSelectedItems = [];
    this.dropdownSettings.departmentDropdownList = [];
    this.dropdownSettings.departmentSelectedItems = [];
    this.dropdownSettings.assignedToDropdownList = [];
    this.dropdownSettings.assignedToSelectedItems = [];
    this.dropdownSettings.countrySelectedItems = [];
    this.dropdownSettings.settings = {
      text: 'Select..',
      selectAllText: 'Select All',
      unSelectAllText: 'Select All',
      classes: 'myclass custom-class',
      badgeShowLimit: 1,
    };
  }

  /** get allowed country ids */
  getAllowedCountries() {
    let countryIds: any = [];
    if (!this.userInfo.hasSystemRole) {
      if (this.userInfo.allowedOperatingCountries) {
        countryIds = this.userInfo.allowedOperatingCountries.split(',');
        countryIds.sort(function (id1, id2) {
          if (id1 < id2) { return -1; }
          if (id1 > id2) { return 1; }
          return 0;
        });

        return countryIds[0];
      }
    }
    return OperatingCountryEnums.USA;
  }

  subscribeTabContent() {
    this.messageService.getCustomerServiceTabContent().subscribe((data: any) => {
      if (data) {
        this.id = data.id;
        this.tabTitle = data.tabName;
        this.componentName = data.componentName;
        this.addNewTab();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
        this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
      }
    });
  }

  addNewTab(): void {
    this.tabModel = new ViewTabModel();
    this.tabModel.id = this.id;
    this.tabModel.title = this.tabTitle;
    this.tabModel.disabled = false;
    this.tabModel.removable = true;
    this.tabModel.active = true;
    this.tabModel.componentName = this.componentName;
    this.existedValues = new Array<ViewTabModel>();
    const index = this.tabs.map(function (el) {
      return el.id;
    }).indexOf(this.id);
    if (this.tabs.length === Constants.MaximumTabsLength) {
      // need to display information -- as you reached maxiumum number of tabs.
      this.displayAlertBoxOnReachingMaxTabs();
    } else {
      if (index < 0) {
        this.tabs.push(this.tabModel);
      } else {
        const selectedId = this.id;
        this.tabs.forEach(function (x: ViewTabModel) {
          if (x.id !== selectedId) { x.active = false; }
          else { x.active = true; }
        });
      }
    }
  }

  /*** display alert box on reaching maximum no of tabs = 8*/
  displayAlertBoxOnReachingMaxTabs() {
    this.deleteModal.toggle = true;
    this.deleteModal.message = CommonMessage.tabsMessage;
  }

  /*** To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs*/
  subscribeClosedTabs() {
    this.messageService.getCloseTabsEvent().subscribe((data: any) => {
      if (data) {
        this.closeAllOpenedTabs();
      }
    });
  }

  /** * Close all opened tabs */
  closeAllOpenedTabs() {
    this.tabs = []; //new Array<DynamicTabModel>();
    this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
    this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
  }

  /** get status types */
  getTicketStatus() {
    if (this.statusTypes) {
      this.statusTypes.sort(function (item1, item2) {
        const status1 = item1.value.toLowerCase(), status2 = item2.value.toLowerCase();
        if (status1 < status2) { return -1; }
        if (status1 > status2) { return 1; }
        return 0;
      });
      this.dropdownSettings.statusSelectedItems = [];
      this.statusTypes.forEach(item => {
        this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
        if (item.id === Status.InProgress || item.id === Status.New || item.id === Status.OnHold) {
          this.dropdownSettings.statusSelectedItems.push({ id: item.id, itemName: item.value });
        }
        this.statusOnSelectAll = false;
      });

    }
  }

  /** * get operating countries */
  getOperatingCountries(onLoad?: boolean) {
    if (onLoad && this.operatingCountries && this.operatingCountries.length > 0) {
      this.loadCountries(onLoad);
    }
    else {
      this.loadOpCoAndDep(true);
    }
  }

  sortOpCo() {
    const countryInfo = this.operatingCountries.find((country: any) => country.id === this.countryId);
    if (countryInfo) {
      this.operatingCountries.splice(this.operatingCountries.indexOf(countryInfo), 1);
      this.operatingCountries.splice(0, 0, countryInfo);
    }
    this.sortingtypes(this.dropdownSettings.countryDropdownList);
  }

  loadCountries(onLoad?: boolean) {
    this.dropdownSettings.countryDropdownList = []
    this.dropdownSettings.countrySelectedItems = [];
    this.departments = this.allDepartment ? this.allDepartment : [];
    const FDdepartments = this.departments.filter(data => data.value.toLowerCase().trim() == Department.FD.toLowerCase().trim());
    FDdepartments.forEach((FDdata) => {
      this.operatingCountries.forEach((countries) => {
        if (countries.id == FDdata.customId) {
          this.dropdownSettings.countryDropdownList.push({ id: countries.id, itemName: countries.name.trim() });
        }
      })
    })
    this.sortOpCo();
    this.fdOperatingCountries = this.dropdownSettings.countryDropdownList
    this.dropdownSettings.countrySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.countryDropdownList));
    this.countryOnSelectAll = true;
    this.iterateticket(onLoad)
  }

  /** get ticket type and subtype* if(true) then get api call* */
  iterateticket(load?: boolean) {
    if (load) {
      const fdDepartments = this.departments.filter(data => data.value.toLowerCase().trim() == Department.FD.toLowerCase().trim());
      const fdIds = fdDepartments.map(department => department.id);
      this.fdDepartmentId = [...fdIds];
      let reqs = [];
      reqs.push(this.departmentService.getTicketTypesAndSubTypes().pipe(catchError((err: any) => {
        return of({ isError: true })
      })));
      if (fdIds && fdIds.length>0) {
        reqs.push(this._customerservice.getAssignedUsersByDepartmentIds(fdIds).pipe(catchError((err: any) => {
          return of({ isError: true })
        })));
      }
      if (reqs.length > 0) {
        forkJoin(reqs).subscribe(response => {
          if (response && response.length > 0) {
            this.ticketTypes = response[0] && Array.isArray(response[0]) ? response[0] : [];
            this.allTicketTypes = response[0] ? response[0]:[];
            this.populateTypeSubtype(this.allTicketTypes, true);
            this.assignedUsers = response[1] ? response[1]:[];
            this.populateAssignedUsers(this.assignedUsers, true);
          }
          else {
            this.assignEmptyToTypeandSubType();
          }
        },
          error => {
            this.assignEmptyToTypeandSubType();
          }
        );
      }
    }
    else {
      this.getDepartmentByCountry();
    }

  }

  /**
 * 
 * @param allTypes filter type and subtypes based on all tickect types
 */
  populateTypeSubtype(allTypes, onLoad?: boolean) {
    this.assignEmptyToTypeandSubType();
    if (allTypes.length>0 && !allTypes.isError && !this.isDiputeTicketSearch ) {
      this.ticketTypes = allTypes;
      this.iterateList(this.ticketTypes)
      this.sortingtypes(this.dropdownSettings.typeDropdownList);
      this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
      this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
      this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.subTypeDropdownList));
      this.ticketTypeOnSelectAll = true;
      this.subTypeOnSelectAll = true;
    }
    else if (allTypes.length>0 && !allTypes.isError && this.isDiputeTicketSearch ) {
      this.ticketTypes = allTypes;
      this.iterateList(this.ticketTypes)
      this.sortingtypes(this.dropdownSettings.typeDropdownList);
      this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
      this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
      this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.subTypeDropdownList));
      this.ticketTypeOnSelectAll = true;
      this.subTypeOnSelectAll = true;
    }
    else if (allTypes.isError == true ) {
      this.assignEmptyToTypeandSubType();
      this.ticketTypeOnSelectAll = false;
      this.subTypeOnSelectAll = false;
    }
    else if ((allTypes.length === 0 || this.allTicketTypes.length === 0) && !onLoad) {
      this.iterateticket(true);
      this.ticketTypeOnSelectAll = false;
      this.subTypeOnSelectAll = false;
    }
    else{
      this.ticketTypeOnSelectAll = false;
      this.subTypeOnSelectAll = false;
    }
  }

  iterateList(allTypes) {
    const tickets: any = allTypes.filter(type => (this.dropdownSettings.countrySelectedItems.find(countries => countries.id == type.operatingCountry)))
    tickets.forEach((item) => {
      let operatingCountryName: string;
      if (item.operatingCountryName !== null) { operatingCountryName = item.operatingCountryName.trim(); }
      const ticketType = operatingCountryName + ' ' + '-' + ' ' + item.value.trim();
      this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: ticketType });
      item.subTypes.forEach((subType: any) => {
        const subTypeName = operatingCountryName + ' ' + '-' + ' ' + subType.name.trim();
        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
      });
    });
  }

  /**
   * 
   * @param allUsers assign required user based on availabe countries
   */
  populateAssignedUsers(allUsers, onLoad?: boolean) {
    this.dropdownSettings.assignedToDropdownList = [];
    this.dropdownSettings.assignedToSelectedItems = [];
    if (allUsers.length > 0 && !allUsers.isError) {
      this.users = allUsers;
      this.users = this.users.filter(item => item.id !== 1);
      this.users.forEach((item) => {
        this.dropdownSettings.assignedToDropdownList.push({
          id: item.id,
          itemName: item.name.trim(),
        });
      });
      this.sortingtypes(this.dropdownSettings.assignedToDropdownList);
      this.dropdownSettings.assignedToSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.assignedToDropdownList));
      this.assignToOnSelectAll = true;
      if (onLoad) {
        this.onSearch();
      }
    }
    else if (allUsers.length === 0 || allUsers.isError == true) {
      this.users = [];
      this.dropdownSettings.assignedToDropdownList = [];
      this.dropdownSettings.assignedToSelectedItems = [];
      this.assignToOnSelectAll = false;
    }
  }

  /**
 * set empty values to type and subtype
 */
  assignEmptyToTypeandSubType() {
    this.dropdownSettings.subTypeDropdownList = [];
    this.dropdownSettings.subTypeSelectedItems = [];
    this.dropdownSettings.typeDropdownList = [];
    this.dropdownSettings.typeSelectedItems = [];
  }

  loadOpCoAndDep(onLoad?: boolean) {
    let reqs = [];
    reqs.push(this._customerservice.getAllBusinessEntities().pipe(catchError((err: any) => {
      return of({ isError: true })
    })));
    reqs.push(this._customerservice.getDepartments().pipe(catchError((err: any) => {
      return of({ isError: true })
    })));

    if (reqs.length > 0) {
      forkJoin(reqs).subscribe((response: any) => {
        if (response && response.length > 0) {
          this.operatingCountries = response[0] && Array.isArray(response[0]) ? response[0] : [];
          this.allDepartment = response[1] && Array.isArray(response[1]) ? response[1] : [];
          let departmentIds = this.userInfo.privileges.departments.map(a => a.id) ? this.userInfo.privileges.departments.map(a => a.id) : [];
          const FdDepartments =  this.allDepartment? this.allDepartment.filter(dept => dept.value.toLowerCase() == Department.FD.toLowerCase().trim()) : [];
          if (this.operatingCountries && this.operatingCountries.length > 0 && this.allDepartment && this.allDepartment.length > 0) {
            if (this.userInfo.hasSystemRole && FdDepartments.length>0) {
              this.allDepartment = this.allDepartment;
              this.getOperatingCountries(true);
            }
            else if (!this.userInfo.hasSystemRole && departmentIds && departmentIds.length > 0) {
              this.allDepartment = this.allDepartment.filter(item => departmentIds.indexOf(item.id) != -1 && item.value.toLowerCase() === Department.FD.toLowerCase());
              this.getOperatingCountries(true);
            }
            
          }
        }
        else {
          this.operatingCountries = [];
          this.allDepartment = [];
        }
      }, error => {
        this.operatingCountries = [];
        this.allDepartment = [];
      })
    }
    else {
      this.operatingCountries = [];
      this.allDepartment = [];
    }
  }

  getDepartmentByCountry() {
    clearTimeout(this.departmentTimeoutID);
    this.departmentTimeoutID = setTimeout(() => {
      this.populateTypeSubtype(this.allTicketTypes,false)
      const deptArr = this.departments.filter((dept) =>
        dept.value.toLowerCase() === Department.FD.toLowerCase() &&
        dept.customId === (this.dropdownSettings.countrySelectedItems.find((country) => country.id === dept.customId)
          ? this.dropdownSettings.countrySelectedItems.find((country) => country.id === dept.customId).id : null));
      this.dropdownSettings.departmentSelectedItems = [];
      deptArr.forEach((item) => {
        this.dropdownSettings.departmentSelectedItems.push({ id: item.id, itemName: item.value });
      });
      this.getAssignedUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id), false);
    }, 0);
  }

  getAssignedUsersByDepartments(departmentIds: number[], onLoad?: Boolean) {
    if (departmentIds && departmentIds.length > 0) {
      this.dropdownSettings.assignedToDropdownList = [];
      this.dropdownSettings.assignedToSelectedItems = [];
      this.fdDepartmentId = [...departmentIds]
      this._customerservice.getAssignedUsersByDepartmentIds(departmentIds).subscribe((response) => {
        if (response) {
          this.users = response;
          this.users = this.users.filter(function (item) { return item.id !== 1; });
          this.users.forEach((item) => {
            this.dropdownSettings.assignedToDropdownList.push({
              id: item.id, itemName: item.name.trim(),
            });
          });
          this.sortingtypes(this.dropdownSettings.assignedToDropdownList);
          this.dropdownSettings.assignedToSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.assignedToDropdownList));
          this.assignToOnSelectAll = true;
          if (onLoad) {
            this.onSearch();
          }
        } else {
          this.users = [];
          this.dropdownSettings.assignedToDropdownList = [];
          this.dropdownSettings.assignedToSelectedItems = [];
        }
      });
    }
  }


  /**
* @description To Search Tickets
* @date 2020-01-31
* @param {boolean} [tabChange]
* @memberof FormTicketsComponent
*/
  onSearch(tabChange?: boolean): void {
    const searchBtn = document.getElementById('search-button');
    if (searchBtn) {
      searchBtn.classList.add('button-active');
      setTimeout(() => {
        searchBtn.classList.remove('button-active');
      }, 1000);
    }
    if (!tabChange) {
      this.pageNumber = 1;
    } else {
      this.pageNumber = isNaN(this.pageNumber) ? 1 : this.pageNumber;
    }
    if (this.dropdownSettings.countrySelectedItems && this.dropdownSettings.countrySelectedItems.length > 0) {
      this.getTicketsSearch(false);
    }
  }

  getTicketsSearch(fetchAllrecords: boolean, isClearSelectedItems?: boolean) {
    if(this.fdTicketsForm.valid && !(this.fdTicketsForm.get('ticketNumber').value && this.fdTicketsForm.get('email').value )){ 
    if (isClearSelectedItems) {
      this.selectAll = false;
      this.selectedTickets = [];
    }
    if (this.isAllSelectedTicketsSpamedOrUnspamed) {
      this.resetTicketSpamOrUnspamForm();
      this.isAllSelectedTicketsSpamedOrUnspamed = false;
    }
    if (!(this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length > 0)) {
      this.dropdownSettings.statusSelectedItems.push({ id: Status.InProgress, itemName: Status[Status.InProgress] });
      this.statusOnSelectAll = false;
    }
    this.selectedTickets=[];
    this.isFormInvalid=false;
    this._customerservice.SearchTicketsOnPagination(null,
      (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.assignedToSelectedItems.map((item: any) => item.id) : []),
      this.ticketSearchModel.ticketNumber,
      (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
      (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
      null,
      (this.fdDepartmentId && this.fdDepartmentId.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.fdDepartmentId : []),
      (this.dropdownSettings.statusSelectedItems.map((item: any) => item.id)), null,
      this.pageNumber ? this.pageNumber : 1, this.pageSize,
      this.sortColumn,
      this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.unAssinged : null,
      this.fdTicketsForm.get('email').value ? this.fdTicketsForm.get('email').value :null,
      this.fdTicketsForm.get('email').value && this.fdTicketsForm.get('operatingCountryId').value.length>0? this.fdTicketsForm.get('operatingCountryId').value.map(country=>country.id):null,null,null,false)
      .subscribe((response: WorkTicket[]) => {
        if (response) {
          this.pageCount = response['totalCount'];
          this.allTickets = response['content'];
          this.fdTickets = response['content'];
          if (this.fdTickets && this.fdTickets.length) {
            this.fdTickets.forEach((x) => {
              if (x.dueDate) { x.dueDate = moment.utc(x.dueDate).utcOffset(0).format('DD-MMM-YYYY'); }
              if (x.createdDate) { x.createdDate = moment.utc(x.createdDate).utcOffset(0).format('DD-MMM-YYYY'); }
              if (x.modifiedDate) { x.modifiedDate = moment.utc(x.modifiedDate).utcOffset(0).format('DD-MMM-YYYY'); }
              if (this.selectedTickets.find((ticket) => ticket.id === x.id)) { x.isSelected = true; }
              if (x.operatingCountryId) { x.operatingCountryId = this.operatingCountries.find((ticket) => x.operatingCountryId === ticket.id).name; }
            });
            this.selectAll = this.fdTickets.every((ticket) => ticket.isSelected === true);
          }
          this.selectedCountries = this.ticketSearchModel.ticketNumber ? [] : this.dropdownSettings.countrySelectedItems;
        } else {
          this.pageCount = 0;
          this.allTickets = [];
          this.fdTickets = [];
        }
      });
    this.setFocusToTextBox();
  }
  }


  onItemSelect(item: any, indexValue: any) {
    if (this.dropdownSettings.statusIndex === +indexValue) {
      this.statusOnSelectAll = false;
      if (this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length) {
        this.statusOnSelectAll = true;
      }
    } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
      this.subTypeOnSelectAll = false;
      if (this.dropdownSettings.subTypeDropdownList.length === this.dropdownSettings.subTypeSelectedItems.length) {
        this.subTypeOnSelectAll = true;
      }
    } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
      this.assignToOnSelectAll = false;
      this.unAssinged = false;
      if (this.users.length === this.dropdownSettings.assignedToSelectedItems.length) {
        this.assignToOnSelectAll = true;
        this.unAssinged = true;
      }
    } else if (this.dropdownSettings.countryIndex === +indexValue) {
      this.countryOnSelectAll = false;
      if (this.fdOperatingCountries.length === this.dropdownSettings.countrySelectedItems.length) {
        this.countryOnSelectAll = true;
      }
      this.iterateticket(false)
    }

    if (this.dropdownSettings.typeIndex === +indexValue) {
      if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
        this.iterateSubTypes();
        this.ticketTypeOnSelectAll = false;
        if (this.dropdownSettings.typeDropdownList.length === this.dropdownSettings.typeSelectedItems.length) {
          this.ticketTypeOnSelectAll = true;
        } else {
          this.ticketTypeOnSelectAll = false;
        }
      }
    }

  }

  onItemDeSelect(item: any, indexValue: any) {
    if (this.dropdownSettings.typeIndex === +indexValue) {
      if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
        this.iterateSubTypes();
        this.ticketTypeOnSelectAll = false;
      } else {
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
      }
    }
    if (this.dropdownSettings.statusIndex === +indexValue) {
      this.statusOnSelectAll = false;
      if (this.showAllTickets) {
        this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
        this.statusOnSelectAll = true;
      } 
    } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
      this.assignToOnSelectAll = false;
      this.unAssinged = false;
      if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
        this.unAssinged = true;
      }
    } else if (this.dropdownSettings.countryIndex === +indexValue) {
      this.countryOnSelectAll = false;
      this.iterateticket(false)
    } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
      this.subTypeOnSelectAll = false;
      this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
    }
  }
  onSelectAll(items: any, indexValue: any) {
    if (this.dropdownSettings.typeIndex === +indexValue) {
      this.iterateSubTypes();
      this.ticketTypeOnSelectAll = true;
    } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
      this.assignToOnSelectAll = true;
      this.unAssinged = true;
    } else if (this.dropdownSettings.statusIndex === +indexValue) {
      this.statusOnSelectAll = true;
    } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
      this.subTypeOnSelectAll = true;
    } else if (this.dropdownSettings.countryIndex === +indexValue) {
      this.countryOnSelectAll = true;
      this.iterateticket(false)
    }
  }

  onDeSelectAll(items: any, indexValue: any) {
    if (this.dropdownSettings.typeIndex === +indexValue) {
      this.dropdownSettings.subTypeDropdownList = [];
      this.dropdownSettings.subTypeSelectedItems = [];
      this.ticketTypeOnSelectAll = false;
    } else if (this.dropdownSettings.assignedToIndex === +indexValue) {
      this.assignToOnSelectAll = false;
      if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
        this.unAssinged = true;
      }
    } else if (this.dropdownSettings.statusIndex === +indexValue) {
      this.statusOnSelectAll = false;
    } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
      this.subTypeOnSelectAll = false;
    } else if (this.dropdownSettings.countryIndex === +indexValue) {
      this.countryOnSelectAll = false;
      this.assignToOnSelectAll = false;
      this.dropdownSettings.assignedToSelectedItems = [];
      this.iterateticket(false)
    }
  }

  iterateSubTypes() {
    const selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id);
    this.dropdownSettings.subTypeDropdownList = [];
    this.dropdownSettings.subTypeSelectedItems = [];
    this.ticketTypes.filter((item) => selectedIds.some((index) => index === item.id)).forEach((type) => {
      type.subTypes.forEach((subType: any) => {
        this.dropdownSettings.subTypeDropdownList.push({
          id: subType.id,
          itemName: type.operatingCountryName + ' ' + '-' + ' ' + subType.name.trim(),
        });
      });
    });
    this.sortingtypes(this.dropdownSettings.subTypeDropdownList);
  }

  sortingtypes(data) {
    if (data.length > 0) {
      data.sort(function (item1, item2) {
        const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
        if (tickettype1 < tickettype2) { return -1; }
        if (tickettype1 > tickettype2) { return 1; }
        return 0;
      });
    }
  }

  /*
  on change of check box in tickets grid
  */
  onTicketSelect(event: any, fdTickets?: WorkTicket[], isAllSelected?: Boolean) {
    this.isFormInvalid = false;
    if (event.target.checked) {
      if (fdTickets.length) {
        for (const ticket of fdTickets) {
          if (!ticket.isSelected) {
            ticket.isSelected = true;
            this.ticketSpamOrUnspamForm.controls['ticketId'].setValue(ticket.id);
            this.selectedTickets.push({
              id: ticket.id,
              ticketNumber: ticket.ticketNumber,
            });
          }
        }
        this.selectAll = this.fdTickets.every((ticket) => ticket.isSelected === true);
      }
    } else {
      if (fdTickets.length) {
        for (const ticket of fdTickets) {
          ticket.isSelected = false;
          this.selectedTickets.splice(this.selectedTickets.map((ticket) => ticket.id).indexOf(ticket.id), 1);
        }
        this.selectAll = this.fdTickets.every((ticket) => ticket.isSelected === true);
      }
    }
  }


  /* To spam or unspam the selected tickets */
  spamorUnspamSelectedTickets() {
    const listOfTicketsToBeSpamed = [];
    let spamOrUnspamReason: any;
    let isSpam: boolean;

    if (this.dropdownSettings.statusSelectedItems.length === 1 && this.dropdownSettings.statusSelectedItems[0].id === Status.Closed) {
      isSpam = false;
      spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as unspam');
    } else {
      isSpam = true;
      spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as spam');
    }

    this.selectedTickets.forEach((ticket) => {
      listOfTicketsToBeSpamed.push({
        id: ticket.id,
        ticketNumber: ticket.ticketNumber,
        updatedBy: this.userInfo.userId,
        closeOtherReason: spamOrUnspamReason.value,
      });
    });

    this._customerservice.markATicketorAllTicketsAsSpamOrUnpsam(listOfTicketsToBeSpamed, isSpam).subscribe((response) => {
      if (response) {
        let success: any;
        if (isSpam) {
          success = this._translatePipe.get('success-message.Ticket(s) marked as spam and closed successfully');
        } else {
          success = this._translatePipe.get('success-message.Ticket(s) marked as not spam successfully');
        }
        this._commonService.createNotification('', success.value, NotificationType.SUCCESS);
        this.isAllSelectedTicketsSpamedOrUnspamed = true;
        if (this.selectAll) {
          this.pageNumber = this.pageNumber - 1;
        }
        this.selectAll = false;
        this.getTicketsSearch(false);
      } else {
        let failed: any;
        if (isSpam) {
          failed = this._translatePipe.get('error-message.Tickets couldn\'t be marked as spam');
        } else {
          failed = this._translatePipe.get('error-message.Tickets couldn\'t be marked as unspam');
        }
        this._commonService.createNotification('', failed.value, NotificationType.ERROR);
        this.unselectTicketsWhenSpamOrUnspamFailed();
        this.isAllSelectedTicketsSpamedOrUnspamed = true;
        this.resetTicketSpamOrUnspamForm();
      }
    },
      (error) => {
        const unknown: any = this._translatePipe.get('validation-message.Unknown Error');
        this.message = error != null && error[0] != null
          ? error[0].field + ' : ' + error[0].message
          : unknown.value;
        this._commonService.createNotification('', this.message, NotificationType.ERROR);
        this.unselectTicketsWhenSpamOrUnspamFailed();
        this.isAllSelectedTicketsSpamedOrUnspamed = true;
        this.resetTicketSpamOrUnspamForm();
      }
    );
    this.spamOrUnspamTicketConfirmation.close();
  }

  selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm: any) {
    if (this.ticketSpamOrUnspamForm.valid && ticketSpamOrUnspamForm) {
      if (!this.selectedTickets || this.selectedTickets.length === 0) {
        this.isFormInvalid = true;
        return;
      } else {
        this.openSpamOrUnspamTicketConfirmationPopup();
      }
    } else {
      this.isFormInvalid = true;
    }
  }

  closeSpamOrUnpsamTicketConfirmationPopup() {
    this.spamOrUnspamTicketConfirmation.close();
  }

  openSpamOrUnspamTicketConfirmationPopup() {
    this.spamOrUnspamTicketConfirmation.open();
  }

  unselectTicketsWhenSpamOrUnspamFailed() {
    this.selectedTickets.forEach((selectedTicket) => {
      this.fdTickets.forEach((myTicket) => {
        if (selectedTicket.id === myTicket.id) {
          myTicket.isSelected = false;
        }
      });
    });
  }

  setFocusToTextBox() {
    setTimeout(function () {
      const element = <HTMLInputElement>document.getElementById('ticketType');
      const email = <HTMLInputElement>document.getElementById('email');
      if (element.value) { element.focus(); }
      else if (email.value) { email.focus(); }
      else { element.focus(); }
    }, 1000);
  }

  searchWithTicketNumber() {
    if (this.ticketSearchModel.ticketNumber) {
      this.countryDropdownSettings = { ...this.dropdownSettings.settings, disabled: true }
      this.dropdownSettings.settings = { ...this.dropdownSettings.settings, disabled: true };
      this.dropdownSettings.statusSelectedItems = [...this.dropdownSettings.statusDropdownList];
      this.OnTabSearchFocus();
      this.chRef.detectChanges();
    }
    else if (this.fdTicketsForm.get('email').value) {
      this.countryDropdownSettings = { ...this.dropdownSettings.settings, disabled: false }
      this.dropdownSettings.settings = { ...this.dropdownSettings.settings, disabled: true };
      this.dropdownSettings.statusSelectedItems = [...this.dropdownSettings.statusDropdownList];
      this.OnTabSearchFocus();
      this.chRef.detectChanges();
    }
    else {
      this.countryDropdownSettings = { ...this.dropdownSettings.settings, disabled: false }
      this.dropdownSettings.settings = { ...this.dropdownSettings.settings, disabled: false };
      this.chRef.detectChanges();

    }
  }

  OnTabSearchFocus() {
    const element = document.getElementById('search-button');
    if (element) {
      if (this.fdTicketsForm.get('ticketNumber').value != "")
        element.focus();
    }
    event.preventDefault();
  }

  selectTab(tab: any) {
    this.activetab = tab;
  }

  goToViewTicket(id: any, ticketNumber: any) {
    if (this.isTicketView) {
      const ticketTab = new TicketTabInfo();
      ticketTab.isNewTicket = false;
      ticketTab.ticketID = id;
      ticketTab.title = 'View Ticket - ' + ticketNumber;
      ticketTab.viewTicket = true;
      ticketTab.isFdTicket = true;
      this.messageService.setCustomerServiceUserTabContent(ticketTab);
    } else {
      this.displayAlertbox();
    }
  }

  /**
   * display alert box if the logged in user do not have permission to see the fbo/retail information
   */
  displayAlertbox() {
    this.deleteModal.toggle = true;
    this.deleteModal.message = CommonMessage.noPermissionMessage;
  }

  doNotRemoveFormData() {
    //data should not be removed...
  }

  openDropDown(element: string) {
    const elem = document.getElementById(element);
    const dropDownList = elem.children[0].children[1];
    dropDownList.removeAttribute('hidden');
  }

  onDropDowneBlur(element: string) {
    const elem = document.getElementById(element);
    const dropDownList = elem.children[0].children[1];
    dropDownList.setAttribute('hidden', 'true');
  }

  /*form data to download to pdf/ csv/print*/
  Download(type: string) {
    const columns = [
      this._translatePipe.get('ticketing-system.Priority')['value'],
      this._translatePipe.get('ticketing-system.Ticket#')['value'],
      this._translatePipe.get('ticketing-system.Subject')['value'],      
      this._translatePipe.get('ticketing-system.Country')['value'],
      this._translatePipe.get('ticketing-system.User')['value'],
      this._translatePipe.get('ticketing-system.Type')['value'],
      this._translatePipe.get('ticketing-system.Subtype')['value'],
      this._translatePipe.get('ticketing-system.Status')['value'],
      this._translatePipe.get('ticketing-system.Created Date')['value'],
      this._translatePipe.get('ticketing-system.Last Modified Date')['value']];

    let rowdata = new Array<any>();
    const finalrows = new Array<any>();
    this._customerservice.SearchTicketsOnPagination(null,
      (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.assignedToSelectedItems.map((item: any) => item.id) : []),
      this.ticketSearchModel.ticketNumber,
      (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
      (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
      null,
      (this.fdDepartmentId && this.fdDepartmentId.length > 0 && !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.fdDepartmentId : []),
      (this.dropdownSettings.statusSelectedItems.map((item: any) => item.id)), null,
      this.pageNumber ? this.pageNumber : 1, this.pageSize,
      this.sortColumn,
      this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.fdTicketsForm.get('email').value) ? this.unAssinged : null,
      this.fdTicketsForm.get('email').value ? this.fdTicketsForm.get('email').value :null,
      this.fdTicketsForm.get('email').value && this.fdTicketsForm.get('operatingCountryId').value.length>0? this.fdTicketsForm.get('operatingCountryId').value.map(country=>country.id):null,null,null,true)
      .subscribe((response)=>{
      if (response && response['content']) {
        const tickets=response['content'];
        for (let i = 0; i < tickets.length; i++) {
            rowdata = [];
            const a1 = tickets[i];

        rowdata.push(a1.priorityValue);
        rowdata.push('\t' + a1.ticketNumber);
        rowdata.push(a1.subject);
        rowdata.push(a1.operatingCountryName);
        rowdata.push(a1.assignedToValue ? a1.assignedToValue : '');        
        rowdata.push(a1.ticketType);
        rowdata.push(a1.subType);
        rowdata.push(a1.status);
        rowdata.push(a1.createdDate ? moment.utc(a1.createdDate).utcOffset(0).format('DD-MMM-YYYY') : '');
        rowdata.push(a1.modifiedDate ? moment.utc(a1.modifiedDate).utcOffset(0).format('DD-MMM-YYYY') : '');

        finalrows.push(rowdata);
      }
    
      const title = this._translatePipe.get('ticketing-system.FD Tickets')['value'];
      this._customerservice.ExcelDownload(columns, finalrows, 'FD Tickets', title);
    }

      }
       ) }

  /**
     * sort table by respective column
     * @param sortColumn
     */
  sortTableByColumn(sortColumn: string) {
    this.isDesc = this.sortColumn === sortColumn ? !this.isDesc : this.isDesc;
    this.sort = this.isDesc ? 'DESC' : 'ASC';
    this.sortColumn = sortColumn;
    //added this condition not to hit service if there are no items in grid.
    if (this.fdTickets.length === 0) {
      return;
    }
    this.getTicketsSearch(false);
  }
  /**
   * On Page change
   * @param pageNumber
   */
  pageChange(pageNumber: number) {
    if (!isNaN(pageNumber)) {

      this.pageNumber = pageNumber;
      this.getTicketsSearch(false);

    }
  }

  clearFields() {
    this.resetContent();
  }

  resetContent() {
    this.intializeMultiselectDropdowns();
    this.setFocusToTextBox();
    this.fdTicketsForm.get('email').setValue('');
    this.ticketSearchModel = new SearchModel();
    this.ticketSearchModel.ticketNumber = '';
    this.ticketSearchModel.overDueCount = false;
    this.tabModel = new ViewTabModel();
    this.dropdownSettings.settings = { ...this.dropdownSettings.settings, disabled: false };
    this.countryDropdownSettings = { ...this.dropdownSettings.settings, disabled: false }
    this.isDiputeTicketSearch ? (this.disputeSearch = true) : '';
    this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
    this.deleteModal.viewActionButtons = false;
    this.countryId = this.getAllowedCountries();
    this.active = false;  
    this.showAllTickets = false;
    this.fieldTypes = new SearchRequestConstants();
    this.assignedToId = this.userInfo.userId;
    this.overDueDisable = false;
    this.closed = Status.Closed;
    if (this.userInfo.privileges.departments && !this.userInfo.hasSystemRole) {
      this.userDepartments = this.userInfo.privileges.departments.map(function (a) { return a.id; });
    }
    this.resetTicketSpamOrUnspamForm();
    if (this.isClearClicked) {
      this.isClearClicked = false;
      this.getTicketStatus();
      this.getOperatingCountries(true);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/fd-tickets.component.ts